// Scroll reveal — IntersectionObserver
document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('.shopify-section:not(.slideshow-section)');
  targets.forEach(el => el.classList.add('section-animate'));

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.section-animate').forEach(el => observer.observe(el));
});
